import {
	useBranchProductSalesChannelItemDisableMutation,
	useBranchProductSalesChannelItemRestoreMutation,
} from "@/generated/graphql";

// Mirrors the backend enum: the table is shared, `type` is the discriminator.
export const BRANCH_PRODUCT_ITEM_TYPE_EXCLUDE = "exclude";
export const BRANCH_PRODUCT_ITEM_TYPE_OUT_OF_STOCK = "out_of_stock";

export interface BranchProductItemDisableInput {
	branchID: string;
	productID: string;
	salesChannelID: string;
	salesChannelCategoryGroupID?: string | null;
	type: string;
	note?: string;
}

export interface BranchProductItemRestoreInput {
	branchID: string;
	productID: string;
	salesChannelID: string;
	type: string;
}

export const useBranchProductSalesChannelItemMutations = () => {
	const [, disable] = useBranchProductSalesChannelItemDisableMutation();
	const [, restore] = useBranchProductSalesChannelItemRestoreMutation();

	return {
		disable: (input: BranchProductItemDisableInput) => disable({ input }),
		restore: (input: BranchProductItemRestoreInput) => restore({ input }),
	};
};
